import { connect } from 'react-redux';
import i18next from 'i18next';
import React from 'react';

import { Dropdown, INPUT_WIDTH } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_FONTS } from '@commons/Text';

import { Container, SupplierProductsContainer } from './styledComponents';

const ModalContent = (props) => {
  const { supplierProducts, selectedSupplierProducts, setSelectedSupplierProducts } = props;

  const formattedSupplierProducts = supplierProducts.map((supplierProduct) => ({
    ...supplierProduct,
    value: `${supplierProduct.name}-${supplierProduct.sku}`,
  }));

  return (
    <Container>
      <Text font={ENUM_FONTS.TEXT_BIG_HEIGHT_24}>
        {i18next.t('STOCKS.STOCKS.LIST_ADD_REFERENCES_WITH_ZERO_SUBTITLE')}
      </Text>
      <SupplierProductsContainer>
        <Dropdown
          customDropdownListStyle={{ maxHeight: '144px' }}
          customStyle={{ position: 'inherit' }}
          height={'64px'}
          isUniqueSelection={false}
          items={formattedSupplierProducts}
          label={`${i18next.t('GENERAL.SUPPLIER_PRODUCT_PLURAL')} :`}
          selectedItems={selectedSupplierProducts}
          width={INPUT_WIDTH.XXL}
          isRequired
          onSelectionChange={setSelectedSupplierProducts}
        />
      </SupplierProductsContainer>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.baseReducer.user,
});

export default connect(mapStateToProps)(ModalContent);
